import React from 'react';
import clsx from 'clsx';
import EnterpriseLayout from "../components/layout/EnterpriseLayout";
import TransactionTableWithCSV from '../components/TransactionTableWithCSV';
import styles from '../styles/views/Transactions.module.scss';

function CreditFeePayments() {
  return (
    <EnterpriseLayout
      pageTitle="Credit Fee Payments"
      pageDescription="Monitor all your credit fee payments in real-time. Track your fee payment history across all supported networks and stable coins."
      pageBodyClassName={clsx(styles.cTransactions, "c-credit-fee-payments")}
    >
      <div className={styles.transactionsContainer}>
        {/* Main Content */}
        <div className={styles.mainContent}>
          <div className={styles.tableSection}>
            <TransactionTableWithCSV 
              filter="credit-fee-payments"
              csvFilename="credit-fee-payments"
            />
          </div>
        </div>
      </div>
    </EnterpriseLayout>
  );
}

export default CreditFeePayments;
